// вспомогательные функции
function hexToRgb(hex) {
  if (!hex) hex = "#b54a4a";
  hex = hex.replace(/^#/, "");
  if (hex.length === 3)
    hex = hex
      .split("")
      .map((c) => c + c)
      .join("");
  const num = parseInt(hex, 16);
  return { r: (num >> 16) & 255, g: (num >> 8) & 255, b: num & 255 };
}

function rgbToHex({ r, g, b }) {
  return "#" + [r, g, b].map((x) => x.toString(16).padStart(2, "0")).join("");
}

function rgbToHsl({ r, g, b }) {
  r /= 255;
  g /= 255;
  b /= 255;
  const max = Math.max(r, g, b),
    min = Math.min(r, g, b);
  let h = 0,
    s = 0,
    l = (max + min) / 2;
  if (max !== min) {
    const d = max - min;
    s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
    switch (max) {
      case r:
        h = (g - b) / d + (g < b ? 6 : 0);
        break;
      case g:
        h = (b - r) / d + 2;
        break;
      case b:
        h = (r - g) / d + 4;
        break;
    }
    h *= 60;
  }
  return { h, s, l };
}

function hslToRgb({ h, s, l }) {
  h /= 360;
  let r, g, b;
  if (s === 0) {
    r = g = b = l;
  } else {
    const hue2rgb = (p, q, t) => {
      if (t < 0) t += 1;
      if (t > 1) t -= 1;
      if (t < 1 / 6) return p + (q - p) * 6 * t;
      if (t < 1 / 2) return q;
      if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
      return p;
    };
    const q = l < 0.5 ? l * (1 + s) : l + s - l * s;
    const p = 2 * l - q;
    r = hue2rgb(p, q, h + 1 / 3);
    g = hue2rgb(p, q, h);
    b = hue2rgb(p, q, h - 1 / 3);
  }
  return {
    r: Math.round(r * 255),
    g: Math.round(g * 255),
    b: Math.round(b * 255),
  };
}

function wrap360(h) {
  return ((h % 360) + 360) % 360;
}
function wrap180(h) {
  const x = wrap360(h);
  return x > 180 ? x - 360 : x;
}
function toGray(hex) {
  const { r, g, b } = hexToRgb(hex);
  const y = Math.round(0.2126 * r + 0.7152 * g + 0.0722 * b);
  return rgbToHex({ r: y, g: y, b: y });
}

// формула сдвига
export default function (hexColor, baseAccent, targetAccent) {
  if (targetAccent == baseAccent) return hexColor;

  const baseH = rgbToHsl(hexToRgb(baseAccent)).h;
  const targetH = rgbToHsl(hexToRgb(targetAccent)).h;
  const deltaH = wrap180(targetH - baseH);

  if (targetH < 0.01) {
    return toGray(hexColor);
  }

  const hsl = rgbToHsl(hexToRgb(hexColor));
  hsl.h = wrap360(hsl.h + deltaH);
  return rgbToHex(hslToRgb(hsl));
}

// тест
// const newColor = shiftHue('#b86a6f', '#cb4646', '#0077ff')
// console.log(newColor)
